module.exports = __webpack_public_path__ + "public/img/聚量@1x.b9ac7acb.png";